export const BUTTON_VARIANT_PRIMARY = 'primary'
export const BUTTON_VARIANT_SECONDARY = 'secondary'
export const BUTTON_VARIANT_LINK = 'link';
export const BUTTON_VARIANT_APP_SECONDARY = 'app_secondary';
export const BUTTON_VARIANT_UPGRADE = 'upgrade'